module.exports = __webpack_public_path__ + "static/media/r34.65878ecf.jpg";